import React from 'react';
import Control from '../../componentsPrestamo/Cuotas/ControlCuotas'

const Control_cuotas = () => {
    return ( 
        <Control/>
     );
}
 
export default Control_cuotas;